import {IntegrationOption, IntegrationType} from 'types/integration';
import {
  GoogleDriveIcon,
  ShopifyBrandIcon,
} from 'pages/Settings/Integrations/icons';

export const INTEGRATION_OPTIONS: IntegrationOption[] = [
  {
    logo: <ShopifyBrandIcon width={120} height={120} />,
    company_name: 'Shopify',
    description:
      'Shopify is a powerful ecommerce platform that allows you to create and manage your online store.',
    url: 'https://www.shopify.com',
    integration_type: 'shopify',
    entities: ['customers', 'products', 'orders'],
  },

  {
    logo: <GoogleDriveIcon width={120} height={120} />,
    company_name: 'Google Drive',
    description:
      'Google Drive is a cloud storage service that allows you to store and share your files.',
    url: 'https://www.google.com/drive',
    integration_type: 'google_drive',
    entities: [],
  },
];

export const INTEGRATIONS: Record<IntegrationType, IntegrationOption> = {
  shopify: {
    logo: <ShopifyBrandIcon width={120} height={120} />,
    company_name: 'Shopify',
    description:
      'Shopify is a powerful ecommerce platform that allows you to create and manage your online store.',
    url: 'https://www.shopify.com',
    integration_type: 'shopify',
  },
  google_drive: {
    logo: <GoogleDriveIcon width={120} height={120} />,
    company_name: 'Google Drive',
    description:
      'Google Drive is a cloud storage service that allows you to store and share your files.',
    url: 'https://www.google.com/drive',
    integration_type: 'google_drive',
  },
};

export const INTEGRATION_OPTIONS_LABELS: Record<IntegrationType, string> = {
  shopify: 'Shopify',
  google_drive: 'Google Drive',
};
